import { Prospector } from '@clearkit/icons';
import classNames from 'classnames';
import { CKButton, CKTooltip } from 'clearkit';
import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';

import { trackEvent } from '~/lib/tracking';

import { prospectorPath, ProspectorSource } from '../prospector/util';

const ProspectorButton = ({
  domain,
  name,
  loading,
  type,
}: {
  domain: string;
  name?: string;
  loading: boolean;
  type: ProspectorSource;
}) => {
  const displayName = name || domain;
  const buttonLabel = `Find prospects at ${displayName}`;

  const handleOnClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    trackEvent(
      type === 'target_markets'
        ? 'target_markets_prospector_opened'
        : 'visitor_report_prospector_opened',
      {
        domain,
        type: 'single',
      },
    );
  };

  return (
    <CKTooltip
      aria-label="Add to Prospector"
      hasHover={!loading}
      placement="bottom-end"
      tooltip={buttonLabel}
      tooltipMaxWidth="25ch"
    >
      <CKButton
        aria-label={buttonLabel}
        as={Link}
        className={classNames('!px-2', {
          'ck-skeleton': loading,
        })}
        onClick={handleOnClick}
        size="small"
        to={prospectorPath({
          source: type,
          domain,
        })}
      >
        <Prospector />
      </CKButton>
    </CKTooltip>
  );
};

export default ProspectorButton;
